if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');      
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message') || this.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        console.log(errorMessage)
        if (errorMessage.includes("You can't add more")) {
          this.removeAttribute("hidden");
          this.errorMessage.textContent = 'It is not possible to add anymore of this product to the cart';
          let errorPort = this
          setTimeout(function(errorPort){
            errorPort.setAttribute("hidden", "");
          }, 1500)
        } else {
          this.errorMessage.textContent = errorMessage;
        }
        
      }
    }
  });
}

if(document.querySelector('.product__drawer')) {
  const attachOpenEvent = (accordion) => {
    accordion.addEventListener('click', (e) => {
      const drawer = e.target.closest('.product__accordion').getAttribute('aria-controls')
      document.getElementById(drawer).setAttribute('aria-expanded', true);
      document.querySelector('body').classList.add('--slideout-open');

      if(drawer === 'product__drawer--faq') {
        document.querySelector('.product__drawer--faq .accordion__question').click();
      } else if (drawer === 'product__drawer--delivery') {
        document.querySelector('.product__drawer--delivery .accordion__question').click();
      }
    });
  }

  const attachCloseEvent = (close) => {
    close.addEventListener('click', () => {
      document.querySelector('.product__drawer[aria-expanded="true"]').setAttribute('aria-expanded', false);
      document.querySelector('body').classList.remove('--slideout-open');
    });
  }

  const overlay = document.createElement("div");
  overlay.classList.add("slideout-overlay");
  document.body.appendChild(overlay);
  attachCloseEvent(document.querySelector('.slideout-overlay'));

  document.querySelectorAll('.product__accordion').forEach(accordion => {
    attachOpenEvent(accordion);
  });

  document.querySelectorAll('.product__drawer .close-icon').forEach(close => {
    attachCloseEvent(close);
  });

  if(document.querySelector('.product__drawer--description')){
    attachCloseEvent(document.querySelector('.product__drawer--description .product-form__submit'));
  }
}



if(document.querySelector('.product__drawer__accordion')) {
  const attachAccordionEvent = (accordion) => {
    accordion.addEventListener('click', (e) => {
      if (e.target.closest('.accordion__question').getAttribute('aria-expanded') === 'false'){
        if(document.querySelector('.accordion__question[aria-expanded="true"]')) {
          document.querySelector('.accordion__question[aria-expanded="true"]').setAttribute('aria-expanded', false);
        }
        if(document.querySelector('.accordion__answer[aria-expanded="true"]')) {
          document.querySelector('.accordion__answer[aria-expanded="true"]').setAttribute('aria-expanded', false);
        }
        e.target.closest('.accordion__question').setAttribute('aria-expanded', true);
        document.getElementById(e.target.closest('.accordion__question').getAttribute('aria-controls')).setAttribute('aria-expanded', true);
      } else if (e.target.closest('.accordion__question').getAttribute('aria-expanded') === 'true'){
        document.querySelector('.accordion__question[aria-expanded="true"]').setAttribute('aria-expanded', false);
        document.querySelector('.accordion__answer[aria-expanded="true"]').setAttribute('aria-expanded', false);
      }
    });
  }

  document.querySelectorAll('.accordion__question').forEach(accordion => {
    attachAccordionEvent(accordion);
  })
}

if(document.querySelector('#product__media-swiper')) {
  document.querySelectorAll('#product__media-swiper .product__media').forEach(thumbnail => {
    thumbnail.addEventListener('click', (e) => {
      if (typeof e.target.dataset.imgUrl != 'undefined') {
        document.querySelector('.product__media-featured img').setAttribute('src', e.target.dataset.imgUrl);
      }
    });
  });
}